import { HeaderState } from 'models/HeaderState';

export const getStores = (state: HeaderState) => (state.stores ? state.stores.stores : []);
